(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('gbFrictionlessEditModalCtrl', [
        '$rootScope',
        '$scope',
        '$sce',
        '$uibModalInstance',
        '$translate',
        'SourceConstant',
        'AppConstants',
        'RegionService',
        'EndpointService',
        'localStorageService',
        'MessageManager',
        'CompanionService',
        'authenticatedUser',
        'ClientMetricsService',
        gbFrictionlessEditModalController
    ]);

    function gbFrictionlessEditModalController($rootScope, $scope, $sce, $uibModalInstance, $translate, SourceConstant, AppConstants, RegionService,
        EndpointService, localStorageService, MessageManager, CompanionService, authenticatedUser, ClientMetricsService) {
        $scope.clientDownloadUrl = CompanionService.getCompanionDownloadUrl();
        $scope.getHeading = function() {
            return  $translate.instant('MODAL.LAUNCH_APP.INSTALL_WORKDOCSCLIENT');
        };
        $scope.getMessage = function() {
            var message =  $translate.instant('MODAL.LAUNCH_APP.FRICTIONLESS_EDIT_CLIENT_INTRO1');
            return $sce.trustAsHtml(message);
        };
        $scope.onDownloadButtonClicked = function() {
            $rootScope.companionDownloadButtonClicked = true;
            $scope.$close();
        };
    }
}());
